import fetchOptionsPlusAcceptLanguage from './internal/fetch-options-plus-accept-language';
import hashData from '@os/hash';

const IN_FLIGHT = {};
const CACHE = {};

/**
* Fetch a url, cache it for future calls up to `cacheAge` ms (or indefinitely if not supplied).
*
* @returns {Promise<object>} Promise with the json parsed value of the response
*/
export default function jsonFetch(url, opts = {}, cacheAge) {
	if (!url || !url.length) {
		console.error('ERR: Invalid URL - ', url);
	}

	opts = fetchOptionsPlusAcceptLanguage(opts);

	const cacheKey = hashData(url + JSON.stringify(opts));
	let { value, expiry } = CACHE[cacheKey] || {};
	if (expiry && expiry <= Date.now()) {
		value = undefined;
		delete CACHE[cacheKey];
	}

	return (
		(value && Promise.resolve(value)) ||
		IN_FLIGHT[cacheKey] ||
		(IN_FLIGHT[cacheKey] = fetch(url, opts)
			.then(r => delete IN_FLIGHT[cacheKey] && r)
			.catch(e => delete IN_FLIGHT[cacheKey] && Promise.reject(e))
			.then(r => {
				if (r.ok) {
					let value = r.json();
					CACHE[cacheKey] = { value, expiry: cacheAge && (Date.now() + cacheAge) };
					return value;
				}

				return Promise.reject(Error(`Network Error. Response Code ${r.status}`));
			}))
	);
}
